// src/api/contactsApi.js
// fetch() does NOT throw on 4xx/5xx — we must check response.ok manually
// and throw so callers (useContacts) can catch and display the message.

const BASE = "/api/contacts";

async function handleResponse(response) {
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const data = await response.json();
      // ✅ FIX 1: pull the server error string so UI can show it
      if (data?.error) message = data.error;
    } catch (_) {}
    throw new Error(message);
  }
  return response.json();
}

export async function loadContacts(authHeaders = {}) {
  const response = await fetch(BASE, {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeaders },
  });
  const data = await handleResponse(response);
  // Both the old inline route and the new route file return { contacts: [...] }
  return Array.isArray(data) ? data : (data.contacts || []);
}

export async function addContact(payload, authHeaders = {}) {
  const response = await fetch(BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders },
    body: JSON.stringify(payload),
  });
  // ✅ FIX 1: handleResponse throws with the server error string on 4xx
  return handleResponse(response);
}

export async function updateContact(contactId, payload, authHeaders = {}) {
  const response = await fetch(`${BASE}/${encodeURIComponent(contactId)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeaders },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
}

export async function deleteContact(contactId, authHeaders = {}) {
  const response = await fetch(`${BASE}/${encodeURIComponent(contactId)}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeaders },
  });
  return handleResponse(response);
}